import { render, staticRenderFns } from "./FeePriceForm.vue?vue&type=template&id=20d4d93e&scoped=true&"
import script from "./FeePriceForm.vue?vue&type=script&lang=js&"
export * from "./FeePriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4d93e",
  null
  
)

export default component.exports